import { useMemo } from 'react';
import { loadCurrentUser } from '@/hooks/useAdminAuth';
import type { Permission, RoleKey } from '@/utils/rbac';
import { hasPermissionMulti } from '@/utils/rbac';

export interface RBACHook {
  currentUser: ReturnType<typeof loadCurrentUser>;
  roles: RoleKey[];
  can: (permission: Permission) => boolean;
  canAll: (permissions: Permission[]) => boolean;
  canAny: (permissions: Permission[]) => boolean;
  isSuperAdmin: boolean;
}

export function useRBAC(): RBACHook {
  const currentUser = useMemo(() => {
    const user = loadCurrentUser();
    console.log('🔍 useRBAC - loaded user from sessionStorage:', user);
    return user;
  }, []);
  const roles: RoleKey[] = (currentUser?.roles ?? []) as RoleKey[];
  const isSuperAdmin = roles.includes('super_admin');
  console.log('🔍 useRBAC - roles:', roles, 'isSuperAdmin:', isSuperAdmin);

  const can = (permission: Permission): boolean => {
    const hasPermission = isSuperAdmin || 
      (currentUser?.permissions && currentUser.permissions.length > 0 && currentUser.permissions.includes(permission)) ||
      hasPermissionMulti(roles, permission);
    console.log('🔍 useRBAC.can - permission:', permission, 'result:', hasPermission, 'isSuperAdmin:', isSuperAdmin);
    return hasPermission;
  };

  const canAll = (permissions: Permission[]) => permissions.every((p) => can(p));
  const canAny = (permissions: Permission[]) => permissions.some((p) => can(p));

  return { currentUser, roles, can, canAll, canAny, isSuperAdmin };
}
